
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raise-issue",
      function () {
        return require("private-next-pages/raise-issue/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raise-issue"])
      });
    }
  